
import { UseFormReturn } from "react-hook-form";
import { Client } from "@/models/Client";
import { WorkoutType } from "@/models/WorkoutType";
import { FormData, getDefaultFormValues } from "@/components/clients/utils/clientFormSchema";
import { getDefaultSubscriptions, getInitialSubscriptions } from "./formDataUtils";

export const initializeForm = (
  form: UseFormReturn<FormData>,
  open: boolean,
  workoutTypes: WorkoutType[],
  initialData: Client | undefined,
  setActiveTab: (tab: string) => void
) => {
  if (open && workoutTypes.length > 0) {
    if (initialData) {
      form.reset({
        firstName: initialData.firstName,
        lastName: initialData.lastName,
        email: initialData.email,
        birthDate: initialData.birthDate || "",
        gender: initialData.gender || "male",
        weightKg: initialData.weightKg?.toString() || "",
        heightCm: initialData.heightCm?.toString() || "",
        phone: initialData.phone || "",
        address: initialData.address || "",
        notes: initialData.notes || "",
        paymentStatus: initialData.paymentStatus || "unpaid",
        subscriptions: getInitialSubscriptions(initialData, workoutTypes)
      });
    } else {
      form.reset({
        ...getDefaultFormValues(),
        subscriptions: getDefaultSubscriptions(workoutTypes)
      });
    }
    setActiveTab("details");
  }
};
